export default __webpack_public_path__ + "static/media/grey-box.f8f70aa8.jpg";